// components/GlobalRedirectHandler.js
import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useOrganization } from "../lib/context/OrganisationContext";
import { useUser } from "../lib/context/UserContext";

const ORG_ID_REGEX = /^\/([^/]+)\/(.+)$/;

const GlobalRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("ts-auth-token");
  const { updateOrganizationId } = useOrganization();
  const { userData } = useUser();

  const redirectUrl = useCallback(async () => {
    const pathname = location.pathname;
    const query = location.search; // includes ?tab=subscription-details

    const match = pathname.match(ORG_ID_REGEX);
    if (match) {
      // eslint-disable-next-line no-unused-vars
      const [_, orgId, restPath] = match;      

      if (token && userData?.organization_ids?.includes(orgId)) {        
        // Store organisationId in context
        await updateOrganizationId(orgId);

        const redirectTo = `/${restPath}${query}`;
        if (pathname + query !== redirectTo) {
          navigate(redirectTo, { replace: true });
        }
      } else {
        // Optional: redirect to login
        console.warn("User not logged in, skipping redirect.");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, location.pathname, userData]);

  useEffect(() => {
    redirectUrl();
  }, [redirectUrl]);

  return null; // No UI needed
};

export default GlobalRedirectHandler;
